import { FaIcon } from '@/lib/fa'
import { Checkbox } from '@/ui'
import React from 'react'

const ActivityItem = ({ checked, label, onClick, icon = null }) => {
  return (
    <div
      className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2"
      onClick={() => onClick && onClick()}
    >
      <Checkbox checked={checked} readOnly />
      {icon && <FaIcon icon={icon} />}
      <p className="tw-text-sm tw-text-content-base">{label}</p>
    </div>
  )
}

export default ActivityItem
